module.exports = __webpack_public_path__ + "star_white.72bb23c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/white/star_white.png
// module id = 935
// module chunks = 0